import { useAppSelector } from "@/lib/redux/hooks";
import {
  productFilterOptionSelectors,
  productFilterSelectors,
} from "@/lib/redux/store";
import { useMemo } from "react";
import DownloadComponent from "./Download";
import FilterComponent from "./Filter";
import { Container } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Download = DownloadComponent as any;
const Filter = FilterComponent as any;

type Catalog = {
  slug: string;
  title: string;
  downloadURL: string | null;
};

export type HeadingProps = {
  catalogs: Catalog[];
};

const Heading: React.FC<HeadingProps> = (props) => {
  const catalogs = useAppSelector((state) => {
    const filter = productFilterSelectors.selectById(state, "catalog");
    if (!filter) return;

    const optionIds = productFilterOptionSelectors.selectIds(filter);

    const validCatalogs = props.catalogs.filter((catalog) =>
      optionIds.includes(catalog.slug)
    );

    const selectedOption = productFilterOptionSelectors
      .selectAll(filter)
      .find((option) => option.selected);

    return validCatalogs.map((catalog) => ({
      id: catalog.slug,
      title: catalog.title,
      isCurrent: selectedOption?.value === catalog.slug,
    }));
  });

  const downloadUrl = useMemo(() => {
    const currentCatalogId = catalogs?.find((catalog) => catalog.isCurrent)?.id;
    return props.catalogs.find((catalog) => catalog.slug === currentCatalogId)
      ?.downloadURL;
  }, [props.catalogs, catalogs]);

  return (
    <Container>
      <Filter catalogs={catalogs}>
        {downloadUrl && <Download url={downloadUrl} />}
      </Filter>
    </Container>
  );
};

export default Heading;
